import ActionTypes from "../constants/action_types";

export default function setEmptyTopicUses() {
  return {
    type: ActionTypes.TOPIC_USES_SET_EMPTY.SUCCESS,
  };
}
